import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Box, Button, Stack, Typography } from '../../ui/core';
import { formatDateTime, shortId, reasonLabel } from './exclusionFormatters';

const HistoryExclusionsTable = ({ rows, loading, hasMore, loadingMore, onLoadMore }) => (
  <Box>
    {!loading && rows.length === 0 ? (
      <Typography color="text.secondary" sx={{ fontSize: '13px' }}>
        No removed exclusions yet.
      </Typography>
    ) : (
      <TableContainer>
        {/* Seven columns don't fit a narrow card; the container scrolls
            horizontally rather than compressing the timestamps. */}
        <Table size="small" sx={{ minWidth: 1040 }}>
          <TableHead>
            <TableRow>
              <TableCell>Rider</TableCell>
              <TableCell>Driver</TableCell>
              <TableCell>Reason</TableCell>
              <TableCell>Note</TableCell>
              <TableCell>Added</TableCell>
              <TableCell>Removed</TableCell>
              <TableCell>Removal note</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.riderMongoId}</TableCell>
                <TableCell>{row.driverMongoId}</TableCell>
                <TableCell>{reasonLabel(row.reason)}</TableCell>
                <TableCell sx={{ maxWidth: 220 }}>
                  <Typography noWrap title={row.note || ''} sx={{ fontSize: '13px' }}>
                    {row.note || '—'}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Stack spacing="2px">
                    <Typography sx={{ fontSize: '13px' }} title={row.createdBy || ''}>
                      {row.createdBy ? shortId(row.createdBy) : 'Unknown admin'}
                    </Typography>
                    <Typography color="text.secondary" sx={{ fontSize: '12px', whiteSpace: 'nowrap' }}>
                      {formatDateTime(row.createdAt)}
                    </Typography>
                  </Stack>
                </TableCell>
                <TableCell>
                  <Stack spacing="2px">
                    <Typography sx={{ fontSize: '13px' }} title={row.removedBy || ''}>
                      {row.removedBy ? shortId(row.removedBy) : 'Unknown admin'}
                    </Typography>
                    <Typography color="text.secondary" sx={{ fontSize: '12px', whiteSpace: 'nowrap' }}>
                      {formatDateTime(row.removedAt)}
                    </Typography>
                  </Stack>
                </TableCell>
                <TableCell sx={{ maxWidth: 220 }}>
                  <Typography noWrap title={row.removedNote || ''} sx={{ fontSize: '13px' }}>
                    {row.removedNote || '—'}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )}

    {hasMore && (
      <Box sx={{ display: 'flex', justifyContent: 'center', pt: '12px' }}>
        <Button size="small" variant="outlined" disabled={loadingMore} onClick={onLoadMore}>
          {loadingMore ? 'Loading…' : 'Load more'}
        </Button>
      </Box>
    )}
  </Box>
);

export default HistoryExclusionsTable;
